import { render, staticRenderFns } from "./DeliveryPendingPage.vue?vue&type=template&id=00c21768&scoped=true"
import script from "./DeliveryPendingPage.vue?vue&type=script&lang=js"
export * from "./DeliveryPendingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c21768",
  null
  
)

export default component.exports